<script>

    // imports
    import { acceptedFileUploadList, projectSettings } from '../../config';
    import { pageNumber, model } from '../../stores';
    import NavigationButtons from '../../components/NavigationButtons.svelte';

    import FormRow from '../../components/FormRow.svelte';
    import FormColumn from '../../components/FormColumn.svelte';
    import PageSection from '../../components/PageSection.svelte';
    import Input from '../../components/Input.svelte';
    import TextArea from '../../components/TextArea.svelte';
    import Datepicker from '../../components/Datepicker.svelte';

    // props
    export let pageIndex = null;
    export let nextPage = null;
    export let previousPage = null;
    export let persistUrl = null;
    export let pageTitle = null;
    export let disabled = false;
    export let lastVisitedPage = null;

    let required = true;

    // dropzone config
    let id = 'fileUploader';
    let options = {
        url: "/api/file-upload?token=" + $model.RegistrationToken,
        acceptedFiles: acceptedFileUploadList
    };

    // component state updating
    if (!disabled) {
        pageNumber.update(p => pageIndex);
        $model.LastPageVisited = lastVisitedPage;
        document.title = pageTitle || `${projectSettings.classActionName} - Review`;
    }

</script>

<PageSection>

	<FormRow class="justify-content-center confirmation-hide">
		<FormColumn>
			<h4 class="text-center">{@html projectSettings.classActionName}</h4>
			<h1 class="text-center">Please provide the claim details</h1>
		</FormColumn>
	</FormRow>
	    	
    <FormRow class="justify-content-center confirmation-show">
	    <FormColumn>
		    <h2>Claim details</h2>
	    </FormColumn>
    </FormRow>

	<hr class="primary" />

	<div class="confirmation-box-shadow">

        <FormRow>
            <FormColumn cols='12'>
                <Input {required} {disabled} label="Nursing Home Name" id="NursingHomeName" bind:value="{$model.NursingHomeName}"></Input>
            </FormColumn>
        </FormRow>

        <FormRow>
            <FormColumn cols='8'>
                <Input {required} {disabled} label="Name of Deceased" id="NameOfDeceased" bind:value="{$model.NameOfDeceased}"></Input>
            </FormColumn>
            <FormColumn cols='4'>
                <Datepicker {required} {disabled} label="Date of Death" id="DateOfDeath" bind:formattedSelected="{$model.DateOfDeath}"
                    openOnClass="calendar-open"
                    validator="true"></Datepicker>
            </FormColumn>
        </FormRow>

        <FormRow>
            <FormColumn cols='12'>
                <TextArea {disabled} id="AdditionalComments" label="Is there anything else you'd like to share with us?" bind:value="{$model.AdditionalComments}" autoExpand rows={4}></TextArea>
            </FormColumn>
        </FormRow>

    </div>

	<FormRow class="confirmation-hide">
		<FormColumn class="last">
            <NavigationButtons {persistUrl} {previousPage} {nextPage}></NavigationButtons>
        </FormColumn>
    </FormRow>

</PageSection>

<style>

</style>